import buildRoute from './buildRoute'

export const getHistogramData = async (deviceSerial: string, histogramType: 'ect' | 'speedload' | 'knock') => {
    try {
        const res = await buildRoute({
            type: 'post',
            route: 'get-histogram-data',
            data: { deviceSerial, histogramType },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const getAllHistogramData = async (deviceSerial: string) => {
    try {
        const res = await buildRoute({
            type: 'post',
            route: 'get-all-histogram-data',
            data: { deviceSerial },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}
